const EN = {
    title: 'Management',
    unsubscription: {
        title: 'Unsubscriptions',
        table: {
            columns: {
                id: 'ID',
                date: 'Date',
                client: 'Client',
                managed: 'Managed',
                status: 'Status',
                actions: 'Actions',
                details: 'Details'
            },
            status: {
                title: 'Status',
                1: 'Pending',
                2: 'Approved',
                3: 'Rejected',
                4: 'Review',
                5: 'Canceled'
            },
            details: {
                title: 'Details',
                by: 'by: ',
                modal: {
                    title: 'Client unsubscription',
                    managed: 'Managed by',
                    date: 'Date',
                    client: 'Client',
                    unsubscriptionDate: 'Managed at',
                    document: 'INE',
                    reason: 'Reason'
                }
            }
        }
    },
    consultants: {
        title: 'Admissible consultants',
        subTitle: 'Admissible consultants',
        manage: 'Manage consultants',
        alert: {
            error: {
                extension: 'The file format is invalid',
                size: 'The file is empty or exceeds the 1 MB limit.',
                upload: 'An error occurred while uploading the file, please try again'
            }
        },
        dragZone: {
            buttonDrag: 'Select file',
            active: 'Drop files here...',
            inactive: 'Select or drag the file',
            subtitle: 'xls or xlsx, weight less than 1 MB'
        },
        buttonCancel: 'Cancel',
        buttonConfirm: 'Upload',
        loadButton: 'Load admissible consultants',
        constants: {
            file: 'Row ',
            created: 'Were created: ',
            updated: 'Were modified: ',
            total: 'Total records processed: ',
            consultants: ' consultants'

        },
        validateErrors: {
            headerFail: 'The first row does not appear to be a valid header.',
            emptyRows: 'The file does not contain any rows with data.',
            rowsExceeded: 'The file contains more rows than allowed (10.000).',
            rowsSparse: 'The file does not contain exactly 11 columns.',
            invalidColumns: 'Does not have exactly 7 columns.',
            emptyCell: 'The cell must not be empty.',
            invalidDni: 'The INE is not valid (it must have between 7 and 8 digits).',
            duplicatedDni: 'The INE is duplicated in the file.',
            invalidGender: 'The gender is not valid (it must be "M" or "F").',
            invalidSupportCard: 'The value in Support Card is not valid (it must be "si" or "no").',
            invalidCardLimitValue: 'The card limit must be a number.',
            invalidCardLimitAmount: 'The card limit must be greater than 0 if the Support Card is "si".',
            invalidSupportPaymentLink: 'The value in Support Payment Link is not valid (it must be "si" or "no").',
            invalidSupportAccount: 'The value in Support Account is not valid (it must be "si" or "no").',
            invalidLevel: 'The value in Level is not valid.',
            invalidDwellTime: 'The value in Dwell Time is not valid (it must be a text).',
            invalidSector: 'The value in Sector is not valid (it must be a text).',
            invalidManagement: 'The value in Management is not valid (it must be a text).'
        },
        success: 'Document processed successfully',
        fail: 'The file could not be processed',
        table: {
            title: 'Admissible Consultants list',
            placeholder: 'Search by INE...',
            columns: {
                id: 'ID',
                fullName: 'Full Name',
                document: 'INE',
                level: 'Level',
                gender: 'Gender',
                time: 'Time at home',
                sector: 'Sector',
                management: 'Management',
            }
        }
    },
    fraudPrevention: {
        title: 'Fraud prevention',
        subTitle: 'List of Rules for Payment Links',
    },
};

export default EN;
